let localtestingURL;
// * For local testing uncomment which site you want to test
// TODO make language dependant?

localtestingURL = "omadiabetes.fi";
// localtestingURL = "mydiabetes.chat";

export const currentWebsiteURL = (window.location.hostname === "localhost") ? localtestingURL : window.location.hostname;
